// built-in imports
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { AnimatePresence } from "framer-motion";

// internal imports
import { Wrapper, Header } from "./projects.styles";
import ProjectsSlider from "../projects-slider/projects-slider.component";
import sectionWrapper from "../../hoc/sction-wrapper.component";
import Slider from "../tags-slider/tags-slider.component";
import Title from "../title/title-component";
import Tab from "../tab/tab.component";
import handsOnProjects from "../../utils/data/hands-on.projects.json";
import collaboratedProjects from "../../utils/data/collaborated-projects.json";

const Projects = () => {
  const [activeTab, setActiveTab] = useState("hands-on");
  const [projects, setProjects] = useState(handsOnProjects?.projects);

  const handleTab = (tab) => {
    if (tab === "hands-on") {
      setProjects(handsOnProjects?.projects);
    } else {
      setProjects(collaboratedProjects?.projects);
    }
    setActiveTab(tab);
  };
  return (
    <Wrapper className="section" id="projects">
      <Header>
        <Title
          align="left"
          title={
            activeTab === "hands-on" ? (
              <FormattedMessage
                id="hands-on-projects"
                defaultMessage="Hands-On Projects"
              />
            ) : (
              <FormattedMessage
                id="collaborative-projects"
                defaultMessage="Collaborative Projects"
              />
            )
          }
        />
        <Tab activeTab={activeTab} handleTab={handleTab} />
      </Header>
      <ProjectsSlider data={projects} />
      <Slider />
    </Wrapper>
  );
};
export default sectionWrapper(Projects);
